import React from 'react';
import PropTypes from 'prop-types';
import AddIcon from '@material-ui/icons/Add';
import Tooltip from '@ublend-npm/react-tooltip';

import { Container, Button } from './AddAssignmentButton.styled';

const AddAssignmentButton = ({
  shouldShowAddAssignmentButton,
  isAssignmentButtonDisabled,
  onClick,
}) => {
  if (!shouldShowAddAssignmentButton) {
    return null;
  }

  const clickHandler = isAssignmentButtonDisabled ? () => {} : onClick;

  const ariaLabel = isAssignmentButtonDisabled
    ? 'disabled add an assignment button'
    : 'active add an assignment button';

  return (
    <Container>
      <Tooltip
        title="Only assignments using percentages can be combined."
        position="top"
        spacing={4}
        enabled={isAssignmentButtonDisabled}
      >
        <Button
          onClick={clickHandler}
          aria-label={ariaLabel}
          disabled={isAssignmentButtonDisabled}
          tabIndex="0"
          role="button"
        >
          <AddIcon />
          Add an assignment
        </Button>
      </Tooltip>
    </Container>
  );
};

AddAssignmentButton.propTypes = {
  shouldShowAddAssignmentButton: PropTypes.bool,
  isAssignmentButtonDisabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

AddAssignmentButton.defaultProps = {
  shouldShowAddAssignmentButton: false,
  isAssignmentButtonDisabled: false,
};

export default AddAssignmentButton;
